import React from "react";
import SockJsClient from 'react-stomp';
import { getAccessToken } from "../../utils/authentication.service";
import { useDispatch } from "react-redux";

const WebSocket = ({children}) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-undef
  const websocketUrl = process.env.REACT_APP_WEBSOCKET_URL;

  var url = `${websocketUrl}/ws?access_token=${getAccessToken()}`;
  var topics = [
    "/user/queue/assetProcessed",
    "/user/queue/assetEditors",
    "/user/queue/datasourceSync",
    "/user/queue/account",
    "/user/queue/assetMergeProcessed",
    "/user/queue/assetAnalyticsUpdate",
    "/user/queue/generatedQuestionProcessed",
    "/user/queue/simulationEvaluationProcessed",
    "/user/queue/generatePodcastTranscription",
    "/user/queue/generatePodcastAudio",
    "/user/queue/editPodcastTranscription",
    "/user/queue/generateCallRecordingTranscription",
    "/user/queue/generateCallRecordingProfile",
    "/user/queue/generateCoachingArticle",
    "/user/queue/generateUploadCallEvaluation",
    "/user/queue/generateUploadCallTranscription",
    "/user/queue/identifyMicroLearningModality"
  ];

  return (
    <div>
      <SockJsClient
        url={url}
        topics={topics}
        onMessage={(msg) => {
          dispatch(msg);
        }}
      ></SockJsClient>
      {children}
    </div>
  );
};

export default WebSocket;
